import { PHASE_DEVELOPMENT_SERVER } from 'next/constants';
import { getPImageUrl } from '../libs/p-img';

export default function wweLoader({ src: originSrc, width, quality }) {
  if (
    originSrc.endsWith('.svg') ||
    (originSrc.startsWith('/') && PHASE_DEVELOPMENT_SERVER)
  ) {
    return originSrc;
  }

  return getPImageUrl(originSrc, {
    width,
    format: 'webp',
    quality: String(quality || 80),
  });
}
